import React, { useContext, useEffect, useState } from 'react';
import ContextDemanda from '@app/hooks/useQuestionario';
import { Card, Collapse, Icon, Row, Col, Input } from 'antd';
import { Widget } from '@digital/ui';
import { DadosAbaSumario, getSumario, TipoDemanda } from '@app/api/demanda';
import './custom.css';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import moment from 'moment';
import FooterAbaSumario from './FooterAbaSumario';
import { getLoggedId } from '@app/helpers';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import FooterAbaSumarioFaturamentoDireto from './FooterAbaSumarioFaturamentoDireto';
const { Panel } = Collapse;

const AbaSumarioFaturamentoDireto = () => {
  const { id, update, demandaData } = useContext(ContextDemanda);
  const [sumarioData, setSumarioData] = useState<DadosAbaSumario | undefined>();
  const [loading, setLoading] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [spans, setSpans] = useState({
    min: 6,
    max: 18,
  });
  const [order, setOrder] = useState(true);

  const setWidth = () => {
    setScreenWidth(window.innerWidth);
  };

  window.addEventListener('resize', setWidth);

  useEffect(() => {
    if (screenWidth <= 1360) {
      setSpans({ min: 8, max: 24 });
      setOrder(false);
    } else {
      setSpans({ min: 6, max: 18 });
      setOrder(true);
    }
  }, [screenWidth]);

  useEffect(() => {
    if (id) {
      getSumario(id).then(data => {
        if (data) {
          setSumarioData(data);
          setLoading(false);
        }
      });
    }
  }, [id, update]);

  return (
    <>
      {sumarioData && demandaData ? (
        <Collapse
          className="aba-sumario"
          bordered={false}
          defaultActiveKey={'analise'}
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel
            key="analise"
            header={
              <span className={demandaData.statusCodigo === 7 ? 'headerCancelada' : ''}>
                {sumarioData.identificadorTexto} - {TipoDemanda[sumarioData.tipo]} - {sumarioData.statusDemandaTexto}
              </span>
            }>
            <Widget
              className={`aba-sumario-faturamento-direto}`}
              actions={[<FooterAbaSumarioFaturamentoDireto demanda={demandaData} sumarioData={sumarioData} />]}>
              <Row gutter={12} type="flex" className="row-global">
                <>
                  {demandaData.statusCodigo === 7 && (
                    <Col span={24} style={{ paddingBottom: '16px' }}>
                      <label>Justificativa de cancelamento</label>
                      <Input.TextArea
                        id="mrn-textarea-justificativaCancelamento"
                        disabled
                        value={demandaData.justificativaCancelamento}
                      />
                    </Col>
                  )}
                </>

                <Col span={spans.min} order={order ? 0 : 1}>
                  <Card title="Dados Gerais" bordered={false} className="card-sumario">
                    <Row>
                      {' '}
                      <div className="content">
                        <span className="card-list">
                          <span className="card-list-title w60">Data de Abertura da Demanda: </span>
                          <span className="card-list-content w40">
                            {moment(sumarioData.dataAbertura).format(dateFormat)}
                          </span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Demandante: </span>
                          <span className="card-list-content w80">{sumarioData.demandante}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Requisitante: </span>
                          <span className="card-list-content w80">{sumarioData.requisitante}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w30">Gestor Técnico: </span>
                          <span className="card-list-content w70">{sumarioData.gestorTecnico}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Diretoria: </span>
                          <span className="card-list-content w80">{sumarioData.diretoria}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Área: </span>
                          <span className="card-list-content w80">{sumarioData.area}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w30">Departamento: </span>
                          <span className="card-list-content w70">{sumarioData.departamento}</span>
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>

                <Col span={spans.max} order={order ? 1 : 0}>
                  <Card title="Caracterização Geral da Demanda" className="card-sumario">
                    <Row gutter={16}>
                      <Col span={8}>
                        <div className="content">
                          <span className="card-list">
                            <span className="card-list-title w30">Tipo: </span>
                            <span className="card-list-content w70">{TipoDemanda[sumarioData.tipo]}</span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w60">Tipo de Aditivo: </span>
                            <span className="card-list-content w40">{sumarioData.tipoAditivo}</span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w60">Tipo de Contrato: </span>
                            <span className="card-list-content w40">{sumarioData.tipoContrato}</span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w40">N° Contrato: </span>
                            <span className="card-list-content w60">
                              {sumarioData.contrato != sumarioData.contratoGuardaChuva ? sumarioData.contrato : ''}
                            </span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w40">N° PCS: </span>
                            <span className="card-list-content w60">{sumarioData.numeroContratoPcs}</span>
                          </span>
                           <hr />
                            <span className="card-list">
                            <span className="card-list-title w60">N° Contrato Original: </span>
                            <span className="card-list-content w40">{sumarioData.contratoGuardaChuva}</span>
                          </span>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div className="content">
                          <span className="card-list">
                            <span className="card-list-title w40">Tipo de Serviço: </span>
                            <span className="card-list-content w60">{sumarioData.tipoServico}</span>
                          </span>
                          <hr />
                        </div>
                      </Col>
                      <Col span={8}>
                        <div className="content">
                          <span className="card-list">
                            <span className="card-list-title w60">Prazo Aditivo: </span>
                            <span className="card-list-content w40">
                              {sumarioData.prazoAditivo ? moment(sumarioData.prazoAditivo).format(dateFormat) : 'N/A'}
                            </span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w80">Prazo Acumulado (Meses): </span>
                            <span className="card-list-content w20">{sumarioData.vigencia}</span>
                          </span>
                          <hr />
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <div className="content-footer">
                        <hr />
                            <span className="card-list">
                            <span className="card-list-title">Fornecedor Contrato Original: </span>
                            <span className="card-list-text">{sumarioData.fornecedorContratoOriginal}</span>
                          </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title">Objeto: </span>
                          <span className="card-list-text">{sumarioData.objeto}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title">Justificativa: </span>
                          <span className="card-list-text">{sumarioData.justificativa}</span>
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>

                <Col span={spans.min} order={2}>
                  <Card title="Caracterização de Valor da Demanda" bordered={false} className="card-sumario">
                    <Row>
                      <div className="content">
                        <span className="card-list">
                          <span className="card-list-title w60">Valor Atual: </span>
                          <span className="card-list-content w40">{sumarioData.valorAtual}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Valor Aditivo: </span>
                          <span className="card-list-content w40">{sumarioData.valorAditivo}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Valor Total: </span>
                          <span className="card-list-content w40">{sumarioData.valorPedido}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Tipo de Despesa: </span>
                          <span className="card-list-content w40">{sumarioData.tipoDespesa}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Alocação de Custo: </span>
                          <span className="card-list-content w40">{sumarioData.alocacaoDeCusto}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w40">Item de Serviço: </span>
                          <span className="card-list-content w60 objeto-encurtado">{sumarioData.itemServico}</span>
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>

                <Col span={spans.min} order={5}>
                  <Card title="DDI - Due Diligence de Integridade" bordered={false} className="card-sumario">
                    <Row>
                      <div className="content">
                        <span className="card-list">
                          <span className="card-list-title w60">Elegibilidade DDI: </span>
                          <span className="card-list-content w40">{sumarioData.ddi}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Critério - Prazo: </span>
                          <span className="card-list-content w40">{sumarioData.criterioPrazoDDI}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Critério - Valor: </span>
                          <span className="card-list-content w40">{sumarioData.criterioValorDDI}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w80">Critério - Mão-de-obra em PTR: </span>
                          <span className="card-list-content w20">{sumarioData.haveraMaoDeObraEmPTR}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w70">Critério - Rel. Entidade Publica: </span>
                          <span className="card-list-content w30">{sumarioData.relacionamentoEntidadePublica}</span>
                        </span>
                        <hr />
                      </div>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Widget>
          </Panel>
        </Collapse>
      ) : null}
    </>
  );
};

export default AbaSumarioFaturamentoDireto;
